// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.list-box-group_7146fea9 .list-box-group-caption_7146fea9 {
  cursor: default;
  position: sticky;
  top: -0.334rem;
  z-index: 1;
  color: #657682;
  background-color: #fff;
}
.list-box-group_7146fea9 .list-box-item_7146fea9 {
  padding-left: 2.667rem;
}
.floating_mix_7146fea9.floating_mix_7146fea9 {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
.floating_mix_flipped_7146fea9.floating_mix_flipped_7146fea9 {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"list-box-group": `list-box-group_7146fea9`,
	"list-box-group-caption": `list-box-group-caption_7146fea9`,
	"list-box-item": `list-box-item_7146fea9`,
	"floating_mix": `floating_mix_7146fea9`,
	"floating_mix_flipped": `floating_mix_flipped_7146fea9`
};
export default ___CSS_LOADER_EXPORT___;
